import React from 'react';
import { Link } from 'react-router-dom';
import FindId from '@/components/contents/user/FindId/FindId';
import { getLocaleWordContent } from '@/utils/language.util';

export default function FindIdPage() {
    return (
        <div className="loginbox sub_page">
            <Link to="/" className="tit">
                <h2 className="inner">{getLocaleWordContent('비밀번호 찾기')}</h2>
            </Link>
            <FindId />
        </div>
    );
}
